import { onReady } from './on-ready.js';
import { isActivateKey, activateClick } from './keyboard.js';

function initLazyBackgrounds() {
    document.addEventListener('lazybeforeunveil', (event) => {
        const bg = event.target.getAttribute('data-bg');
        if (bg) {
            event.target.style.backgroundImage = `url(${bg})`;
        }
    });
}

function initLogoScroll() {
    const logo = document.querySelector('.logo');
    if (!logo) {
        return;
    }

    window.addEventListener('scroll', () => {
        if (window.pageYOffset >= 125) {
            logo.classList.remove('big-logo');
        } else {
            logo.classList.add('big-logo');
        }
    });
}

function bindSearchButton(button) {
    if (!button) {
        return;
    }

    const focusSearch = () => {
        document.querySelector('#searchInputAlgolia')?.focus();
    };

    button.addEventListener('click', focusSearch);
    button.addEventListener('keyup', (event) => {
        if (!isActivateKey(event)) {
            return;
        }
        event.preventDefault();
        activateClick(button);
    });
}

function initSearchButtons() {
    bindSearchButton(document.querySelector('#searchButton1'));
    bindSearchButton(document.querySelector('#searchButton2'));
}

function initFilters() {
    document.querySelectorAll('.btn-clear').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
                checkbox.checked = false;
            });
        });
    });

    document.querySelectorAll('.switch-input').forEach((switchInput) => {
        switchInput.addEventListener('click', () => {
            if (switchInput.id === 'usaon' || switchInput.id === 'usaoff') {
                return;
            }

            const withoutMap = document.querySelector('#without-map');
            const withMap = document.querySelector('#with-map');

            if (switchInput.id === 'mapoff') {
                if (withoutMap) withoutMap.style.display = 'block';
                if (withMap) withMap.style.display = 'none';
            } else {
                if (withoutMap) withoutMap.style.display = 'none';
                if (withMap) withMap.style.display = 'block';
            }
        });
    });

    document.querySelectorAll('.postCategory').forEach((select) => {
        select.addEventListener('change', () => {
            window.location.href = select.value;
        });
    });

    document.querySelectorAll('.search-field').forEach((field) => {
        field.addEventListener('keyup', () => {
            document.querySelectorAll('.search-reset').forEach((resetButton) => {
                resetButton.style.display = 'block';
            });
        });
    });

    document.querySelectorAll('.search-reset').forEach((resetButton) => {
        resetButton.addEventListener('click', () => {
            document.querySelectorAll('.search-reset').forEach((button) => {
                button.style.display = 'none';
            });
        });
    });
}

function initTables() {
    const tables = document.querySelectorAll('table');
    if (!tables.length) {
        return;
    }

    document.querySelectorAll('figure.table').forEach((figure) => {
        figure.classList.remove('table');
        figure.classList.add('figure-table');
    });

    tables.forEach((table) => {
        if (table.classList.contains('.table')) {
            table.classList.remove('table');
        } else {
            table.classList.add('table');
            table.classList.add('table-borderless');
        }
    });

    document.querySelectorAll('.table').forEach((table) => {
        const wrapper = document.createElement('div');
        wrapper.classList.add('table-responsive');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);

        table.classList.add('table', 'table-borderless');
        table.removeAttribute('style');

        table.querySelectorAll('td, th, tr, thead, tbody, tfoot').forEach((el) => {
            el.removeAttribute('style');
        });
    });

    tables.forEach((table) => {
        if (table.querySelector('thead')) {
            return;
        }

        const thead = document.createElement('thead');
        table.insertBefore(thead, table.querySelector('tbody'));
        const firstRow = table.querySelector('tbody tr:first-child');
        if (!firstRow) {
            return;
        }

        firstRow.querySelectorAll('td').forEach((td) => {
            const th = document.createElement('th');
            th.scope = 'col';
            th.innerHTML = td.innerHTML;
            [...td.attributes].forEach((attr) => th.setAttribute(attr.name, attr.value));
            td.replaceWith(th);
        });
        thead.appendChild(firstRow);
    });
}

onReady(() => {
    initLazyBackgrounds();
    initLogoScroll();
    initSearchButtons();
    initFilters();
    initTables();
});
